//
//
//
//
//
//
//
//
//
//

import giftSvg from '~/assets/svg/gift.svg?data'
import tearSvg from '~/assets/svg/drop.svg?data'
import clipboardSvg from '~/assets/svg/notepad.svg?data'
import hourglassSvg from '~/assets/svg/hourglass.svg?data'
import walletSvg from '~/assets/svg/wallet.svg?data'
import handsSvg from '~/assets/svg/hands-2.svg?data'

export default {
  name: 'MemberPerks',

  computed: {
    perks() {
      return [
        {
          icon: walletSvg,
          title: 'Over 50% off sitewide*',
          copy: 'with plans + bundles'
        },
        {
          icon: giftSvg,
          title: 'Monthly gifts',
          copy: 'surprises in every box'
        },
        {
          icon: tearSvg,
          title: 'Free samples',
          copy: 'your choice with every order'
        },
        {
          icon: clipboardSvg,
          title: 'Free RD access',
          copy: '1:1 expert advice'
        },
        {
          icon: hourglassSvg,
          title: 'Early access',
          copy: 'first look at new products'
        },
        {
          icon: handsSvg,
          title: 'Refer + earn',
          copy: 'up to $150 in credits'
        }
      ]
    }
  }
}
